<template>
    <Teleport to="body">
        <transition name="fade">
            <div v-if="show" :class="'notif-toast ' + type">
                <div class="message-wrapper">
                    <div style="margin-right: 20px">
                        <div :class="'toast-icon-holder ' + type">
                            <CheckMark v-if="type === 'success'" :size="29" label="Success" />
                            <span class="icon-check-alt toast-icon" v-else-if="type !== 'failure'"></span>
                            <span class="icon-exclamation toast-icon" v-if="type == 'failure'"></span>
                        </div>
                    </div>
                    {{ message }}
                </div>
                <a
                    href="javascript:"
                    class="toast-close icon-close"
                    @click="emit('close')"
                ></a>
            </div>
        </transition>
    </Teleport>
</template>

<script setup lang="ts">
import CheckMark from '@/components/misc/CheckMark.vue'
import { watch } from 'vue'

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: 'info',
    },
    message: {
        type: String,
        default: '',
    },
    duration: {
        type: Number,
        default: 20000,
    },
})

const emit = defineEmits(['close'])

watch(
    () => props.show,
    (current, previous) => {
        if (current && current !== previous) {
            setTimeout(() => {
                emit('close')
            }, props.duration)
        }
    },
)
</script>
